// extracted by mini-css-extract-plugin
export default {"container":"iga-z","zappos":"jga-z","6pm":"kga-z","versional":"lga-z"};